import React, {Fragment} from 'react';
import {useTranslation} from 'react-i18next';
import {makeStyles} from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import WarningIcon from '@material-ui/icons/Warning';
import {FormStatus} from "../../../../models/shared";
import {ContactError, ContactToAdd, MachineContactModel} from "../../../../models/machine.models";
import {ValidationRow} from "../../../_shared/wizard/ValidationRow";
import UserAvatar from "../../../user-avatar/UserAvatar";

const useStyles = makeStyles(theme => ({
    formsContainer: {
        marginTop: theme.spacing(2)
    },
    itemContainer:{
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(1)
    },
    actions: {
        '& > *': {
            marginLeft: theme.spacing(2)
        }
    },
    errorBanner: {
        width: '100%',
        backgroundColor: theme.palette.error.main,
        color: theme.palette.error.contrastText
    },
    errorOption: {}
}));

export interface ContactInviteProcessorProps {
    readonly forms: MachineContactModel[],
    readonly onUpdated: (id: number, contact: Partial<ContactToAdd>) => ContactError | null;
    readonly onRemoved: (id: number | string) => void;
}

export const ContactInviteSummary = ({
                                         forms,
                                         onUpdated,
                                         onRemoved,
                                     }: ContactInviteProcessorProps) => {
    const {t} = useTranslation();
    const classes = useStyles();

    const failedCount = forms.filter(f => f.status === FormStatus.failed).length;

    return <Fragment>
        {
            failedCount > 0 &&
            <Grid container className={classes.errorBanner} justify='center'>
                <WarningIcon/>
                <Typography variant="body2">
                    {t('Subscription.SubscriptionAssignment.XEntriesNeedAttention', {failedCount})}
                </Typography>
            </Grid>
        }
        <Grid container className={classes.formsContainer}>
            {
                forms
                    .map((f, i) =>
                        <ValidationRow processingStatus={f.status}
                                       handleDeleteItem={() => onRemoved(f.id)}
                                       errorMessage={f.errorMessage ? f.errorMessage : '_Common.Api.Messages.FailedToAddContact'}>
                            <Grid container item xs={11} spacing={4} className={classes.itemContainer}>
                                <Grid item className={(classes as any).avatarColumn}>
                                    <UserAvatar userId={typeof f.id === "number" ? undefined : f.id} key={f.id}/>
                                </Grid>
                                <Grid item>
                                    <Typography
                                        variant="body1">{f.data.firstName} {f.data.lastName}</Typography>
                                    <Typography variant="body2" color={'textPrimary'}>{f.data.email}</Typography>
                                </Grid>
                            </Grid>
                        </ValidationRow>
                    )
            }
        </Grid>

    </Fragment>
};
